

export function character_sprites(k){

const omori= add([
    k.sprite("omori_sheet"),
    k.pos(500,500),
    k.scale(3),
    area(),
    z(10),
    "omori"
]);

const aubrey= add([
    k.sprite("aubrey_sheet"),
    k.pos(83,94),
    k.scale(3),
    area({scale:0.5}),
    anchor("center"),
    z(10),
    "aubrey"
]);

const mewo = add([
    k.sprite("mewo", {anim: "idle"}),
    k.pos(27,177),
    k.scale(0.5),
    k.area(),
    z(10),
    "mewo"
]);

const background = add ([
    k.sprite("image_background"),
    k.pos(0,-35),
    k.z(-1),
    "background"
])
 

}